import React, { useEffect, useState } from 'react'
import { api } from '../../../utils'
import LoadingSpinner from '../../atoms/Loading/Loading'
import { Info } from '../../atoms/NewIcons'
import _ from 'lodash'
import FormField from '../../atoms/FormField/FormField'
import FormFile from '../../atoms/FormFile/FormFile'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import useTrans from '../../../hooks/useTrans'
import * as Sentry from '@sentry/browser'
import { AnteprimaLogo } from '../../molecules'

const Posizione = ({ index, onUpload, setFiles, files }) => {
  const [tracciatura, setTracciatura] = useState(false)
  const [tipoFile, setTipoFile] = useState()
  const [file, setFile] = useState(null)
  const t = useTrans()

  const _setFilesObj = () => {
    if (file) {
      const new_files = Object.assign({}, files)
      _.set(new_files, index, { file: file, tracciatura: !tracciatura })
      setFiles(new_files)
    }
  }

  useEffect(() => {
    _setFilesObj()
  }, [file, tracciatura])

  // isTracciaturaDefault comprende tutti i formati dove è possibile mostrare la checkbox per scegliere di inserire la tracciatura
  // const isTracciaturaDefault = ['jpg', 'png', 'psd', 'jpeg', 'pdf']
  // const visualizzaAnteprima = ['jpg', 'jpeg', 'png']

  // Non mostriamo la checkbox per i formati vettoriali ('svg' e 'ai')
  const isTracciaturaDisabled = ['svg+xml', 'postscript']
  // Formati con checkbox NON preflaggata
  const isTracciaturaNotPreflagged = ['pdf']

  const _handleUpload = (e) => {
    setFile(e.target.files[0])
    const type = e.target.files[0].type.toString().toLowerCase().split('/')?.[1]
    setTipoFile(type)

    isTracciaturaDisabled.includes(type) || isTracciaturaNotPreflagged.includes(type)
      ? setTracciatura(false)
      : setTracciatura(true)
  }

  return (
    <div className="posizione">
      <div className="posizione__header">
        <p className="posizione__title">
          {t('Posizione')} {index}
        </p>
      </div>
      <div className="posizione__actions">
        <FormField
          label={
            <span className="posizione__actions__top">
              <span>{t('Logo')}</span>
              {/* <Tooltip label={t('Tooltip logo')}>
                <Info />
              </Tooltip> */}
            </span>
          }
        >
          <FormFile
            placeholder={t('Carica il logo da applicare')}
            name={index}
            filename={file?.name}
            onChange={_handleUpload}
          />
        </FormField>
      </div>
      <div className="image__wrapper">
        {file && (
          <p className="posizione__avviso">
            {t('Se il logo non è in vettoriale verrà addebitato il costo della lavorazione')}
          </p>
        )}
        {file && !isTracciaturaDisabled.includes(tipoFile) && (
          <FormCheckbox
            label={t('Applica tracciatura logo')}
            checked={tracciatura}
            onChange={(e) => setTracciatura(e.target.checked)}
          />
        )}
        <AnteprimaLogo file={file} filename={file?.name || ''} className="posizione__image" />
      </div>
    </div>
  )
}

const UploadLoghi = ({ posizioni, setFromProps, setReload }) => {
  const [Loading, setLoading] = useState(false)
  const [files, setFiles] = useState(null)

  setFromProps &&
    useEffect(() => {
      setFromProps(files)
    }, [files])

  return (
    <div className="upload__loghi">
      {
        <>
          <div className="upload__loghi__posizioni">
            {posizioni &&
              posizioni.map((posizione, index) => (
                <Posizione key={index} index={index + 1} setFiles={setFiles} files={files} />
              ))}
          </div>
          {Loading && <LoadingSpinner />}
        </>
      }
    </div>
  )
}

export default UploadLoghi

export const _uploadLoghi = async ({ id, file_to_upload, setLoading }) => {
  try {
    setLoading(true)
    await api
      .put(`/posizione-personalizzazioni/${id}/logo_file/`, file_to_upload.file, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': `attachment; filename=${file_to_upload.file.name}`,
        },
      })
      .then()
      .catch((err) => {
        Sentry.captureException(err)
      })
    await api
      .patch(`/posizione-personalizzazioni/${id}/`, {
        tracciatura_logo: !file_to_upload.tracciatura,
      })
      .then()
      .catch((err) => Sentry.captureException(err))

    setLoading(false)
  } catch (error) {
    Sentry.captureException(error)
    setLoading(false)
  }
}

// <>
//   {/* TODO: questo bottone non è previsto dalla grafica */}
//   {files && Object.values(files).length > 0 && (
//     <Button
//       label="Carica Loghi"
//       onClick={() => _uploadLoghi({ id: '1', files: files, setLoading: setLoading })}
//     />
//   )}
// </>
